import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import bootCampImage from '../images/bootcamp.jpeg';

const workshopTestimonials = [
  {
    src: require('../images/workshop/WhatsApp Image 2026-06-08 at 5.19.05 PM.jpeg'),
    alt: 'Mini Boot Camp workshop activity session 1',
  },
  {
    src: require('../images/workshop/WhatsApp Image 2026-06-08 at 5.19.05 PM (1).jpeg'),
    alt: 'Mini Boot Camp workshop activity session 2',
  },
  {
    src: require('../images/workshop/WhatsApp Image 2026-06-08 at 5.19.05 PM (2).jpeg'),
    alt: 'Mini Boot Camp workshop activity session 3',
  },
  {
    src: require('../images/workshop/WhatsApp Image 2026-06-08 at 5.19.05 PM (3).jpeg'),
    alt: 'Mini Boot Camp workshop activity session 4',
  },
  {
    src: require('../images/workshop/WhatsApp Image 2026-06-08 at 5.19.06 PM.jpeg'),
    alt: 'Mini Boot Camp workshop participant interaction 1',
  },
  {
    src: require('../images/workshop/WhatsApp Image 2026-06-08 at 5.20.31 PM.jpeg'),
    alt: 'Mini Boot Camp workshop participant interaction 2',
  },
  {
    src: require('../images/workshop/WhatsApp Image 2026-06-08 at 5.20.32 PM.jpeg'),
    alt: 'Mini Boot Camp workshop participant interaction 3',
  },
  {
    src: require('../images/workshop/WhatsApp Image 2026-06-08 at 5.20.32 PM (1).jpeg'),
    alt: 'Mini Boot Camp workshop participant interaction 4',
  },
  {
    src: require('../images/workshop/WhatsApp Image 2026-06-08 at 5.20.54 PM.jpeg'),
    alt: 'Mini Boot Camp workshop participant interaction 5',
  },
  {
    src: require('../images/workshop/WhatsApp Image 2026-06-08 at 5.20.55 PM.jpeg'),
    alt: 'Mini Boot Camp workshop participant interaction 6',
  },
];

function MiniBootCampPage() {
  return (
    <section className="internship-page" aria-labelledby="mini-boot-camp-heading">
      <div className="container internship-page-container">
        <Link className="internship-back-link" to="/#services">
          Back to Services
        </Link>

        <div className="internship-hero-card">
          <img
            src={bootCampImage}
            alt="Mini Boot Camp 2026 participants"
            className="internship-hero-image"
            loading="lazy"
          />
          <div className="internship-hero-content">
            <p className="internship-kicker">Facilitated by Pratidhi Therapy & Wellness LLP</p>
            <h1 id="mini-boot-camp-heading">Mini Boot Camp 2026</h1>
            <p>
              Pratidhi Therapy & Wellness LLP successfully conducted the Mini Boot Camp 2026, a three-day online skill-development program designed for school students from Classes 6-12. The program focused on equipping young learners with essential life skills that contribute to personal growth, emotional wellbeing, and future success.
            </p>
            <p>
              Recognizing that academic achievement alone is not sufficient for thriving in today's world, we designed this boot camp to help students develop confidence, resilience, effective communication, leadership abilities, and a growth-oriented mindset through engaging and practical learning experiences.
            </p>
          </div>
        </div>

        <section className="internship-content-card workshop-testimonials-section" aria-labelledby="workshop-gallery-heading">
          <h2 id="workshop-gallery-heading">Empowering Minds In Action...</h2>
          <p className="workshop-testimonials-intro">
            Highlights from The Mini BootCamp June 2026 sessions, showcasing active participation,
            experiential learning, and student engagement.
          </p>
          <div className="workshop-testimonials-carousel" aria-label="Mini Boot Camp workshop photo carousel">
            <Swiper
              modules={[Pagination, Navigation, A11y, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              loop
              autoplay={{ delay: 2800, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              navigation
              a11y={{ prevSlideMessage: 'Previous workshop photo', nextSlideMessage: 'Next workshop photo' }}
            >
              {workshopTestimonials.map((item, index) => (
                <SwiperSlide key={item.alt}>
                  <figure className="workshop-testimonial-card">
                    <img
                      src={item.src}
                      alt={item.alt}
                      className="workshop-testimonial-image"
                      loading={index === 0 ? 'eager' : 'lazy'}
                    />
                    <figcaption className="workshop-testimonial-caption">
                      Workshop Moment {index + 1}
                    </figcaption>
                  </figure>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>

        <div className="internship-content-grid">
          <article className="internship-content-card">
            <h2>Program Highlights</h2>
            <ul>
              <li>3-Day Intensive Online Boot Camp</li>
              <li>Live Interactive Sessions</li>
              <li>Activity-Based Learning</li>
              <li>Practical Exercises and Reflection Activities</li>
              <li>Group Discussions and Skill-Building Tasks</li>
              <li>Certificate of Participation Provided</li>
            </ul>
          </article>

          <article className="internship-content-card internship-content-card-wide">
            <h2>Key Themes Covered</h2>
            <p><strong>Day 1: Healthy Coping Mechanisms</strong></p>
            <p>
              Students explored healthy ways of managing stress, emotions, and everyday challenges. Through interactive activities and discussions, participants learned practical strategies to build emotional resilience and maintain psychological wellbeing.
            </p>
            <p><strong>Day 2: Communication Skills Masterclass</strong></p>
            <p>
              This session focused on strengthening verbal and non-verbal communication, active listening, self-expression, and interpersonal effectiveness. Students participated in exercises designed to improve confidence and communication in academic, social, and personal settings.
            </p>
            <p><strong>Day 3: Leadership Skills for Teenagers</strong></p>
            <p>
              Participants were introduced to essential leadership qualities, decision-making skills, teamwork, responsibility, and problem-solving abilities. The session encouraged students to recognize their strengths and develop the confidence to take initiative in various aspects of life.
            </p>
          </article>

          <article className="internship-content-card internship-content-card-wide">
            <h2>Learning Methodology</h2>
            <p>
              The Mini Boot Camp was designed to be highly interactive and experiential. We incorporated practical activities, group discussions, role-plays, reflection exercises, and real-life scenarios to ensure meaningful engagement and application of learning.
            </p>
            <p>
              Rather than relying solely on theoretical instruction, the program emphasized skill development through participation, helping students translate concepts into everyday practice.
            </p>
          </article>

          <article className="internship-content-card internship-content-card-wide">
            <h2>Outcomes</h2>
            <p>
              By the end of the program, participants demonstrated greater confidence in expressing themselves, improved communication abilities, enhanced awareness of healthy coping strategies, and a stronger understanding of leadership and teamwork.
            </p>
            <p>
              The boot camp provided students with practical, evidence-informed tools that can support their academic journey, interpersonal relationships, emotional wellbeing, and personal development.
            </p>
          </article>

          <article className="internship-content-card internship-content-card-wide">
            <h2>Certification</h2>
            <p>
              All participants who successfully completed the program were awarded a Certificate of Participation in recognition of their engagement, learning, and commitment throughout the boot camp.
            </p>
          </article>

        </div>
      </div>
    </section>
  );
}

export default MiniBootCampPage;
